import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { AuthService } from '../../../core';
import { NotaSearch } from '../nota-search';

@Component({
    selector: 'sgt-nota-card',
    templateUrl: './nota-card.component.html',
    styleUrls: ['./nota-card.component.less']
})
export class NotaCardComponent implements OnInit {
    idUsuarioLogado: number;
    isEditing = false;
    @Input() nota: NotaSearch;
    notaEditing: NotaSearch;

    @Input() canEdit = true;
    @Output() edit = new EventEmitter<NotaSearch>();
    @Input() canDelete = true;
    @Output() delete = new EventEmitter<NotaSearch>();

    constructor(private authService: AuthService) { }

    ngOnInit(): void {
        this.idUsuarioLogado = this.authService.getIdUsuario();
    }

    editClick() {
        this.isEditing = true;
        this.notaEditing = _.cloneDeep(this.nota);
    }

    cancel() {
        this.isEditing = false;
        this.notaEditing = null;
    }

    save() {
        this.edit.emit(this.notaEditing);
        this.cancel();
    }
}
